import { createMuiTheme, Switch, TextField } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import commonCss from 'theme/commonStyles.module.css';

const themeColors = {
    neutral: {
        10: '#f5f5f5',
        50: '#e0e1e9',
        200: '#b7b9c3',
        300: '#a3a6b1',
        400: '#80848f',
        600: '#6a6e79',
        800: '#464b52'
    },
    blues: {
        blue: '#0063a3',
        blueLight: '#217cbb'
    },
    error: {
        main: '#da212c'
    },
    appSecondaryColor: {
        dark: '#252a2e'
    }
};
const themeFontSizes = {
    small: '.75rem',
    medium: '.875rem',
    large: '1rem'
};
export const inputOptions = {
    overrides: {
        PrivateSwitchBase: {
            root: {
                padding: 4
            }
        },
        MuiSvgIcon: {
            root: {
                fontSize: '1.25rem'
            }
        },
        MuiMenuItem: {
            root: {
                paddingTop: 4,
                paddingBottom: 4
            }
        },
        MuiListItemText: {
            primary: {
                fontSize: '0.875rem'
            }
        },
        MuiFormHelperText: {
            contained: {
                marginBottom: 8,
                marginLeft: 0
            }
        },
        MuiAutocomplete: {
            inputRoot: {
                padding: '0 !important',
                height: 32
            },
            input: {
                padding: '6px !important',
                paddingLeft: '10.5px !important'
            }
        },
        MuiSelect: {
            outlined: {
                '&:focus': {
                    background: 'unset'
                }
            },
            select: {
                '&:focus': {
                    background: 'unset'
                }
            }
        },
        MuiOutlinedInput: {
            root: {
                background: '#fff',
                '&:hover': {
                    '& .MuiOutlinedInput-notchedOutline': {
                        border: `1px solid ${themeColors.neutral[50]}`,
                        borderBottom: `1px solid ${themeColors.neutral[600]}`
                    }
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    border: `1px solid ${themeColors.neutral[50]}`,
                    borderBottom: `2px solid ${themeColors.blues.blueLight}`
                },
                '&$focused $notchedOutline': {
                    border: `1px solid ${themeColors.neutral[50]}`,
                    borderColor: themeColors.neutral[50],
                    borderWidth: 1,
                    borderBottom: `2px solid ${themeColors.blues.blueLight}`
                },
                '&:hover $notchedOutline': {
                    border: `1px solid ${themeColors.neutral[50]}`,
                    borderColor: themeColors.neutral[50],
                    borderBottom: `1px solid ${themeColors.neutral[600]}`
                },
                '&.Mui-error .MuiOutlinedInput-notchedOutline': {
                    border: `1px solid ${themeColors.neutral[50]}`,
                    borderBottom: `2px solid ${themeColors.error.main}`
                },
                '&$error $notchedOutline': {
                    border: `1px solid ${themeColors.neutral[50]}`,
                    borderColor: themeColors.neutral[50],
                    borderWidth: 1,
                    borderBottom: `2px solid ${themeColors.error.main}`
                },
                '&.Mui-disabled': {
                    background: themeColors.neutral[10],
                    '& .MuiOutlinedInput-notchedOutline': {
                        border: `1px solid ${themeColors.neutral[50]}`,
                        borderBottom: `1px solid ${themeColors.neutral[600]}`
                    }
                },
                '&.Mui-disabled .MuiButtonBase-root': {
                    color: themeColors.neutral[400]
                }
            },
            notchedOutline: {
                inset: '0',
                border: `1px solid ${themeColors.neutral[50]}`,
                borderBottom: `1px solid ${themeColors.neutral[600]}`,
                borderRadius: '.125rem',
                '& legend': {
                    display: 'none'
                },
                '&:hover': {
                    borderColor: themeColors.neutral[50]
                }
            },
            input: {
                padding: 16,
                fontSize: themeFontSizes.medium,
                '&.MuiInputBase-inputSizeSmall': {
                    fontSize: themeFontSizes.small,
                    padding: 0
                },
                color: themeColors.appSecondaryColor.dark,
                '::placeholder': {
                    color: themeColors.neutral[200],
                    opacity: 1
                },
                '&.Mui-disabled': {
                    color: themeColors.neutral[400]
                }
            },
            multiline: {
                padding: 12.5,
                height: 'auto',
                '& textarea': {
                    padding: 0
                },
                '&.MuiInputBase-sizeSmall': {
                    fontSize: themeFontSizes.small,
                    padding: 7.5,
                    height: 'auto'
                }
            },
            inputMarginDense: {
                padding: 10.5
            },
            marginDense: {
                height: 32
            }
        },
        MuiInputLabel: {
            defaultProps: {
                shrink: true
            },
            shrink: {
                transform: 'none !important'
            },
            formControl: {
                position: 'unset'
            },
            outlined: {
                transform: 'none !important'
            },
            root: {
                position: 'unset',
                transform: 'none',
                fontSize: themeFontSizes.small,
                color: themeColors.neutral[800],
                '&.Mui-disabled': {
                    color: themeColors.neutral[800]
                },
                '&.Mui-focused': {
                    color: themeColors.blues.blueLight
                }
            }
        }
    }
};

export const GLOBAL_FONT_THEME = {
    fontFamily: "'Open Sans', sans-serif !important"
};

export const DEFAULT_THEME = createMuiTheme({
    typography: GLOBAL_FONT_THEME,
    ...inputOptions
});

export const ACCORDIAN_THEME = createMuiTheme({
    overrides: {
        // Name of the component ⚛️ / style sheet
        MuiExpansionPanelSummary: {
            root: {
                //background: "#005F9E",
                // background: "#009ada",
                borderTopRightRadius: '5px',
                borderTopLeftRadius: '5px',
                minHeight: 48,
                height: 48,
                '&$expanded': {
                    minHeight: 48,
                    height: 48
                }
            },
            expandIcon: {
                color: 'white'
            }
        },
        MuiExpansionPanelDetails: {
            root: {
                display: 'block'
            }
        },
        MuiFormControl: {
            marginNormal: {
                marginTop: '8px !important'
            }
        },
        MuiInputBase: {
            input: {
                padding: '8.5px 10px !important',
                fontSize: '14px'
            }
        },
        MuiPaper: {
            elevation1: {
                boxShadow: 'unset'
            }
        },
        MuiInputLabel: {
            outlined: {
                transform: 'translate(14px, 10px) scale(1)'
            }
        },
        MuiTypography: {
            root: {
                color: '#000 !important'
            },
            body1: {
                fontSize: '16px !important',
                fontWeight: '600'
            },
            caption: {
                fontSize: '14px !important'
            }
        },
        MuiButton: {
            contained: {
                color: 'white',
                backgroundColor: '#005F9E !important'
            }
        },
        MuiExpansionPanelActions: {
            root: {
                padding: '16px 25px !important'
            }
        }
    },
    typography: GLOBAL_FONT_THEME
});

export const SNACK_THEME = createMuiTheme({
    overrides: {
        MuiSnackbarContent: {
            root: {
                background: '#5E9331 !important'
            }
        }
    },
    typography: GLOBAL_FONT_THEME
});

export const SNACK_FAILURE_THEME = createMuiTheme({
    overrides: {
        MuiSnackbarContent: {
            root: {
                background: SNACK_THEME.palette.error.dark
            }
        }
    },
    typography: GLOBAL_FONT_THEME
});

export const INPUT_THEME = createMuiTheme({
    overrides: {
        MuiInputBase: {
            input: {
                padding: '8.5px 10px !important',
                fontSize: '14px'
            }
        },
        MuiModal: {
            root: {
                position: 'absolute !important'
            }
        },
        MuiInputLabel: {
            outlined: {
                transform: 'translate(14px, 10px) scale(1)'
            }
        },

        MuiMenu: {
            paper: {
                maxHeight: '220px'
            }
        }
    },
    MuiMenu: {
        paper: {
            maxHeight: '220px'
        }
    },
    typography: { fontFamily: "'Open Sans', sans-serif !important" }
});

export const SEARCH_BAR_THEME = createMuiTheme({
    typography: GLOBAL_FONT_THEME,
    overrides: {
        MuiInputBase: {
            root: {
                color: '#fff'
            }
        },
        MuiInput: {
            underline: {
                '&:hover:not($disabled):not($error):not($focused):before': {
                    borderBottomColor: '#fff',
                    height: 1
                },
                '&:before': {
                    borderBottom: '1px solid #fff'
                },
                '&:after': {
                    borderBottom: '2px solid #fff'
                }
            }
        }
    }
});

export const PRIMARY_CHIP = createMuiTheme({
    overrides: {
        MuiChip: {
            root: {
                backgroundColor: '#0194d3 !important',
                color: 'white !important'
            },
            deleteIcon: {
                color: '#ffffff82 !important',
                '&:hover:': {
                    color: 'white !important'
                }
            }
        }
    }
});

export const CHECKBOX_STYLE = {
    root: commonCss.checkboxBase,
    checked: commonCss.checkboxChecked,
    disabled: commonCss.checkboxDisabled
};

export const PrimarySwitch = withStyles({
    switchBase: {
        '&$checked': {
            color: '#009ad9 !important'
        },
        '&$checked + $track': {
            backgroundColor: '#009ad9  !important'
        },
        padding: 8
    },
    checked: {},
    track: {}
})(Switch);

export const PrimaryTextField = withStyles({
    ...inputOptions
})((props) => <TextField variant="outlined" fullWidth size="small" {...props} />);

export const DATE_PICKER_THEME = createMuiTheme({
    overrides: {
        ...inputOptions.overrides,
        MuiOutlinedInput: {
            ...inputOptions.overrides.MuiOutlinedInput,
            root: {
                ...inputOptions.overrides.MuiOutlinedInput.root,
                height: 32
            }
        },
        MuiIconButton: {
            root: {
                padding: 0
            }
        },
        MuiSvgIcon: {
            root: {
                width: 16,
                height: 16
            }
        }
    }
});
